import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=5587d847&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=js"
export * from "./CircleLoader.vue?vue&type=script&lang=js"
import style0 from "./CircleLoader.vue?vue&type=style&index=0&id=5587d847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5587d847",
  null
  
)

export default component.exports